// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moderate-for-group__flag svg {
    color: var(--secondary-color-main);
}
.moderate-for-group__rejected svg {
    color: var(--secondary-color-main);
}
`, "",{"version":3,"sources":["webpack://./client/components/groups/moderation/ModerateForGroup/ModerateForGroup.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC","sourcesContent":[".moderate-for-group__flag svg {\n    color: var(--secondary-color-main);\n}\n.moderate-for-group__rejected svg {\n    color: var(--secondary-color-main);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
